import { styled } from 'styled-components';
export const IconWrapper = styled.span `
  display: flex;
  width: 24px;
  height: 24px;
  align-items: center;
  justify-content: center;
`;
export const Animation = styled.div `
  display: flex;
  animation: rotate 1s linear infinite;
  width: 24px;
  height: 24px;
  align-items: center;
  justify-content: center;
  @keyframes rotate {
    100% {
      transform: rotate(360deg);
    }
  }
`;
